import React from 'react';
import { ArrowRight, Clock, Users, Award, Smartphone, LineChart } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';
import { getImageAssetPath } from '@/lib/imageHelper';
import { BusinessHero } from '@/components/ui/content-blocks';

// ProofPoint-Komponente mit Icon
const ProofPoint = ({ icon: Icon, text }) => (
  <div className="flex items-center gap-2 md:text-sm text-xs text-blue-700">
    <Icon className="h-4 w-4 text-blue-700" />
    <span>{text}</span>
  </div>
);

const HeroSection = () => {
  const { t } = useTranslation();
  const heroImagePath = getImageAssetPath('hero-business-app.jpg');

  // ProofPoints für die Hero-Sektion
  const proofPointsSection = (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8 mt-6">
      <ProofPoint 
        icon={Clock}
        text={t('businessAppsPage.header.proofPoints.experience')} 
      />
      <ProofPoint 
        icon={Users}
        text={t('businessAppsPage.header.proofPoints.clients')} 
      />
      <ProofPoint 
        icon={Award}
        text={t('businessAppsPage.header.proofPoints.projects')} 
      />
    </div>
  );

  return (
    <BusinessHero
      title={t('businessAppsPage.header.title')}
      titleHighlight={t('businessAppsPage.header.titleHighlight')}
      subtitle={t('businessAppsPage.header.description')}
      description={t('businessAppsPage.header.details')}
      primaryCTA={{
        label: t('businessAppsPage.header.primaryCTA'),
        href: "#contact",
        icon: <ArrowRight className="h-5 w-5" />
      }}
      secondaryCTA={{
        label: t('businessAppsPage.header.secondaryCTA'),
        href: "#features"
      }}
      image={{
        src: heroImagePath,
        alt: "Business Applications",
        width: 600,
        height: 400
      }}
      badges={[
        {
          icon: <Smartphone className="h-6 w-6 mr-1" />,
          text: "Multi-Device",
          position: "top-right",
          color: "blue"
        },
        {
          icon: <LineChart className="h-6 w-6 mr-1" />,
          text: "Datengetrieben",
          position: "bottom-left",
          color: "blue"
        }
      ]}
      imageInfo={{
        text: "Bild von DC Studio auf Freepik",
        link: "https://de.freepik.com/fotos-kostenlos/ehrgeizige-fuehrungskraefte-arbeiten-im-buero-an-infografiken-berichten-und-der-festlegung-von-zielen_415456000.htm#fromView=search&page=2&position=34&uuid=6c5b820e-2b42-4aab-adaa-f49a61d41f82&query=dashboard"
      }}
      backgroundStyle="default"
      className="pt-12 md:pt-20"
    >
      {proofPointsSection}
    </BusinessHero>
  );
};

export default HeroSection; 